import { Timeline } from "@msuite/ui/timeline";
import { useMemo } from "react";
import { useAttendances } from "@/hooks/use-attendances";
import { AttendanceCard } from "../cards/attendance-card";

export function AttendancesTimeline() {
	/** Hooks */
	const { attendances, fetchNextPage, hasNextPage, isLoading, refetch } = useAttendances();

	const parsed = useMemo(() => {
		return attendances.map((item) => ({
			date: item.title,
			items: item.data.map((dateItem) => ({
				type: "attendanceItem",
				item: dateItem,
			})),
		}));
	}, [attendances]);

	/** Render */
	return (
		<Timeline
			isLoading={isLoading}
			timeline={parsed}
			refetch={async () => {
				await refetch();
			}}
			renderItem={(_, item) => <AttendanceCard item={item} />}
			onEndReached={async () => {
				if (!hasNextPage) return;
				await fetchNextPage();
			}}
		/>
	);
}
